import { getArticleCode } from './articleCode'
import { getLineSellingPriceTp } from './purchaseOrderLinePricing'
import { getOrderLineProductId } from './dsdShipment'
import {
  isProductVatMissing,
  productRequiresVat,
  roundMoney,
  sapCondValueFromPurchasePrice,
} from './sapCondValue'

/**
 * Build VAT review rows from selected shipment quantities.
 * unit_price / selling price is treated as VAT-inclusive (same as SO util).
 */
export function buildShipmentVatReviewRows({
  lines = [],
  qtyByLine = {},
  pendingAdds = [],
}) {
  const rows = []

  for (const li of lines || []) {
    const quantity = Number(qtyByLine?.[li.id]) || 0
    if (quantity <= 0) continue
    const unitPriceIncl = Number(getLineSellingPriceTp(li))
    const vat =
      li.vat === null || li.vat === undefined || li.vat === ''
        ? null
        : Number(li.vat)
    const source = li.product_source || li.source || 'shwapno'
    rows.push({
      key: `line-${li.id}`,
      kind: 'line',
      lineId: li.id,
      productId: getOrderLineProductId(li) || null,
      articleCode: getArticleCode(li) || li.sku || '',
      productName: li.product_name || 'Product',
      quantity,
      unitPriceIncl: Number.isFinite(unitPriceIncl) ? unitPriceIncl : 0,
      vat: Number.isFinite(vat) ? vat : null,
      source,
    })
  }

  for (const add of pendingAdds || []) {
    const quantity = Number(add.quantity) || 0
    if (quantity <= 0) continue
    const unitPriceIncl = Number(add.unit_price)
    const vatRaw = add.vat
    const vat =
      vatRaw === null || vatRaw === undefined || vatRaw === ''
        ? null
        : Number(vatRaw)
    rows.push({
      key: add.key || `pending-${add.admin_product_id}`,
      kind: 'pending',
      productId: String(add.admin_product_id || '').trim() || null,
      articleCode: add.sku || getArticleCode(add) || '',
      productName: add.product_name || 'Product',
      quantity,
      unitPriceIncl: Number.isFinite(unitPriceIncl) ? unitPriceIncl : 0,
      vat: Number.isFinite(vat) ? vat : null,
      // Catalog adds are shwapno-only today; still honor explicit source.
      source: add.product_source || add.source || 'shwapno',
    })
  }

  return rows
}

export function enrichVatReviewRow(row) {
  const requiresVat = productRequiresVat(row.source)
  const vatMissing = requiresVat && isProductVatMissing(row.vat)
  let unitPriceExcl = null
  if (!vatMissing && !isProductVatMissing(row.vat)) {
    try {
      unitPriceExcl = sapCondValueFromPurchasePrice(
        row.unitPriceIncl,
        row.vat,
      )
    } catch {
      unitPriceExcl = null
    }
  } else if (!requiresVat) {
    unitPriceExcl = roundMoney(row.unitPriceIncl)
  }
  const totalIncl = roundMoney(row.unitPriceIncl * row.quantity)
  return {
    ...row,
    requiresVat,
    vatMissing,
    unitPriceExcl,
    unitPriceInclDisplay: roundMoney(row.unitPriceIncl),
    totalIncl,
  }
}

export function findMissingVatReviewRows(rows) {
  return (rows || []).map(enrichVatReviewRow).filter((r) => r.vatMissing)
}
